











































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";
import { ITicketProvider } from "@/models/providers/ticket";

@Component({
  components: {
    "ticket-message": () =>
      import("@/components/app/global/tickets/ticketMessage.vue"),
    "ticket-message-files": () =>
      import("@/components/app/global/tickets/ticketMessageFiles.vue")
  }
})
export default class TicketMessageGroup extends Mixins(Context) {
  // Inject

  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  // Props

  @Prop({ required: true })
  public messages!: any[];

  // Data

  public showHiddenLogs = false;

  // Computed

  public get group() {
    return this.messages[0];
  }

  public get ticketData() {
    return this.$ticketData();
  }

  public messageFiles(files) {
    return this.$_.orderBy(files, ["updated_at"], ["desc"]);
  }

  public get filteredMessages() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [head, ...rest] = this.messages;
    return this.group.isLog ? rest : this.messages;
  }
}
